import React from "react";
import ReactDOM from "react-dom";
import { ReactComponent as ViewIcon } from "../Global Icons/view-icon.svg";
import { ReactComponent as AreaIcon } from "../Global Icons/area-icon.svg";
import { ReactComponent as FurnishedIcon } from "../Global Icons/furnished.svg";
import { ReactComponent as BalconyIcon } from "../Global Icons/balcony-icon.svg";
import { ReactComponent as BathroomIcon } from "../Global Icons/bathroom-icon.svg";
// import TextInput from "../Other/textInput";
// import { editExcel, viewExcel } from "../../Redux/Actions/uploadFile.actions";
// import { useParams } from "react-router-dom";
// import SelectInput from "../Other/dropdownInput";

const UnitDetailsModal = ({ unit, onClose }) => {
  console.log("unit", unit);

  return ReactDOM.createPortal(
    <div className="modal-overlay flex-container flex-center" onClick={onClose}>
      <div
        className="unit-details-container flex-container flex-column"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="unit-details-container-top">
          <img
            src={
              unit.image
                ? unit.image
                : require("../Global Icons/default unit.jpg")
            }
            alt="unit-image"
          ></img>
        </div>

        <div className="unit-details flex-container flex-column">
          <div className="flex-container flex-justify-between">
            <div className="flex-container flex-align-center gap-10 edit-excel-btn">
              <div className="brand-logo-container block-pos flex-container flex-align-center">
                <p
                  style={
                    unit.status === "unavl"
                      ? { textShadow: "1px 2px 6px rgb(255, 81, 0)" }
                      : unit.status === "avl"
                      ? { textShadow: "1px 2px 6px rgb(9, 255, 0)" }
                      : unit.status === "onhold"
                      ? { textShadow: "1px 2px 6px rgb(246, 255, 0)" }
                      : unit.status === "sold"
                      ? { textShadow: "1px 2px 6px rgb(255, 0, 0)" }
                      : {}
                  }
                >
                  {unit.status}
                </p>
              </div>
            </div>
          </div>
          <div className="unit-name-container">
            <p>{unit.category}</p>
            <p>{`${unit.unitno} |  ${unit.unit}`}</p>
          </div>
          {/* <div className="unit-price-wrapper">
            <p>
              {`${formatPrice(
                parseInt(unit.preferredlocationcharges) +
                  parseInt(unit.additionalcharges) +
                  parseInt(unit.basesellingprice)
              )} ${exceldata?.data?.currency}`}
            </p>
          </div> */}
          <div className="flex-container unit-info-more gap-20">
            <div className="unit-info-icon gap-10 flex-container flex-justify-center">
              <AreaIcon />
              <p>{unit.area}</p>
            </div>
            <div className="unit-info-icon gap-10 flex-container flex-justify-center">
              <BathroomIcon />
              <p>{unit.bathroom}</p>
            </div>
            <div className="unit-info-icon gap-10 flex-container flex-justify-center">
              <BalconyIcon />
              <p>{unit.balcony}</p>
            </div>
            <div className="unit-info-icon gap-10 flex-container flex-justify-center">
              <ViewIcon />
              <p>{unit.view}</p>
            </div>
            <div className="unit-info-icon gap-10 flex-container flex-justify-center">
              <FurnishedIcon />
              <p>{unit.furnishingstatus}</p>
            </div>
          </div>
          <div className="unit-info-icon gap-10 flex-container flex-justify-center">
            <p className="margin-10">Base Selling Price:</p>
            <p className="margin-10">{unit["basesellingprice(persq.ft)"]}</p>
          </div>
          <div className="unit-info-icon gap-10 flex-container flex-justify-center">
            <p className="margin-10">Additional Charges</p>
            <p className="margin-10">{unit["additionalcharges(persq.ft)"]} sq.ft</p>
          </div>
          <div className="unit-info-icon gap-10 flex-container flex-justify-center">
            <p className="margin-10">Area:</p>
            <p className="margin-10">{unit["area(sq.ft)"]} sq.ft</p>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnitDetailsModal;
